'use strict';

var storelocator = {
	initVieweSelectionTracker: function () {
		$('.customTabs .tabButtons li a').on('click', function (e) {
			viewSelection(e);
		});
	},
	trackFilterEvent: function (e, event) {
		var obj = {'event': event};
		$.extend(obj, getDataFromPage(e));
		dataLayer.push(obj);
		this.initVieweSelectionTracker();
	},
	initStoreDirectionsTracker: function () {
		$('.get-dir-store-detail').on('click', function (e) {
			var store = $.parseJSON($(this).attr('data-gtmdata'));
			var obj = {
				'store_city': store.city,
				'store_ID': store.ID,
				'store_location_fav': store.favStore,
				'store_name': store.name,
				'store_postcode': store.postalCode,
				'event': 'storeDirections'
			};
			$.extend(obj, getDataFromPage(e));
			dataLayer.push(obj);
		});
	},

	storeViewEvent: function (e) {
		if ($('.get-dir-store-detail').attr('data-gtmdata') !== undefined) {
			var store = $.parseJSON($('.get-dir-store-detail').attr('data-gtmdata'));
			var obj = {
				'store_city': store.city,
				'store_ID': store.ID,
				'store_location_fav': store.favStore,
				'store_name': store.name,
				'store_postcode': store.postalCode,
				'event': 'viewStore'
			};
			$.extend(obj, getDataFromPage(e));
			dataLayer.push(obj);
		}
	}
};

function viewSelection (e) {
	var obj = {'event': 'viewSelection'};
	$.extend(obj, getDataFromPage(e));
	dataLayer.push(obj);
}

/**
 * @description Returns concatenated string of checked filter labels from LOCATION TYPE section
 */
function getTypeFilter() {
	var typeFilter = '';
	$('#secondary #location-type input').each(function () {
		if ($(this).prop('checked') === true && $(this).prop('labels').length > 0) {
			if (typeFilter === '') {
				typeFilter = $(this).prop('labels')[0].innerHTML;
			} else {
				typeFilter += ' | ' + $(this).prop('labels')[0].innerHTML;
			}
		}
	});
	return typeFilter;
}

/**
 * @description Returns concatenated string of checked filter labels from FEATURES section
 */
function getFeatureFilter() {
	var featureFilter = '';
	$('#secondary #feature-type input').each(function () {
		if ($(this).prop('checked') === true && $(this).prop('labels').length > 0) {
			if (featureFilter === '') {
				featureFilter = $(this).prop('labels')[0].innerHTML;
			} else {
				featureFilter += ' | ' + $(this).prop('labels')[0].innerHTML;
			}
		}
	});
	return featureFilter;
}

/**
 * @description Returns selected view type (list, view or N/A)
 */
function getSearchView() {
	var searchView = 'N/A';
	if ($('.tabButtons').find('.active a').length > 0) {
		searchView = $('.tabButtons').find('.active a').attr('href') === '#listTab' ? 'list' : 'map';
	}
	return searchView;
}

/**
 * @param event
 * @description Takes data which is available on a page
 */
function getDataFromPage(e) {

	var obj = {
		'button_ID': e ? e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name : '',
		'location_search_country': $('select[name$=_storelocator_country]').val(),
		'location_search_entered': $('input[name$=_storelocator_postalCode]').val(),
		'location_search_feature_filter': getFeatureFilter(),
		'location_search_results': $('.search-total-count').text(),
		'location_search_type_filter': getTypeFilter(),
		'location_search_view': getSearchView()
	};
	return obj;
}

module.exports = storelocator;
